// @core/api/endpoints/platform/add_platform_member.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddPlatformMemberRequest,
  PlatformMemberResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Add member to platform
 * Adds a user as a member of the platform with the specified role. The user will immediately gain access to platform resources based on their assigned role.
 */
export async function AddPlatformMember(
  platform_id: string,
  data: AddPlatformMemberRequest,
  options?: RequestOptions
): Promise<PlatformMemberResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/members`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.post<PlatformMemberResponse>(requestPath, data, requestOptions);
}
